import SEO from "@/components/SEO";
import { PageHero, Reveal, LegalText } from "@/components/Bits";
import { TERMS_TXT } from "@/content/policies";

export default function Terms() {
  return (
    <div data-testid="terms-page">
      <SEO
        title="Terms & Conditions"
        description="Terms & Conditions governing use of the Middle Man platform — service Work Requests and product marketplace orders. Operator: Tourist Junction Private Limited, Pune."
        path="/terms"
      />
      <PageHero
        kicker="Legal"
        title="Terms & Conditions"
        subtitle="Effective from: 10 September 2026 · Please read carefully before using Middle Man."
      />
      <div className="mx-auto max-w-3xl px-6 py-16 md:py-20">
        <Reveal>
          <LegalText text={TERMS_TXT} />
        </Reveal>
      </div>
    </div>
  );
}
